import { render, staticRenderFns } from "./LoadingThumbnail.vue?vue&type=template&id=b94f631c&scoped=true&"
import script from "./LoadingThumbnail.vue?vue&type=script&lang=js&"
export * from "./LoadingThumbnail.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_thumbnails.scss?vue&type=style&index=0&id=b94f631c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94f631c",
  null
  
)

export default component.exports